<template lang="pug">
.popUp.color_bg_3(v-if="isShow")
  .title.color_text_0 兑换码
  el-input.input.color_divider_2(v-model="exchangeCode" placeholder="请输入超级会员兑换码")
  .operation
    .cancel.color_text_2(@click="cancel") 取消
    .save.color_pc_red.color_text_white(@click="save") 兑换
</template>
<script>
export default {
  data() {
    return {
      isShow: false,
      exchangeCode: '',
    };
  },
  methods: {
    showPopUp() {
      this.isShow = true;
      this.exchangeCode = '';
    },
    cancel() {
      this.isShow = false;
    },
    save() {
      this.$emit('exchange', this.exchangeCode);
    },
  },
};
</script>
<style lang="stylus" scoped>
.popUp
  width 360px
  height 162px
  position absolute
  top 232.5px
  left 138.5px
  box-shadow 0px 6px 30px rgba(0, 0, 0, 0.08)
  border-radius 8px
  z-index 99
  .title
    font-size 18px
    margin 14px 0 0 20px
    line-height 100%
  .input
    width 328px
    height 38px
    margin 14px 0 0 20px
    border-radius 8px
  .operation
    position relative
    font-size 14px
    .cancel, .save
      width 80px
      height 36px
      position: absolute
      top 20px
      text-align center
      line-height 36px
      border-radius 8px
      cursor pointer
    .cancel
      right 108px
      border 1px solid #DCDFE5
    .save
      right 20px
.popUp >>> .el-input__inner
  border-radius 8px
.popUp >>> .el-input__inner:focus, .popUp >>> .el-input__inner:hover
  border 1px solid #E6E7E8
</style>
